__turbopack_context__.v({
  "container": "app-download-module-scss-module__Y6hZyq__container",
  "google_icon": "app-download-module-scss-module__Y6hZyq__google_icon",
  "link": "app-download-module-scss-module__Y6hZyq__link",
});
